export const SALUTES = [
  {
    value: 'Dr.',
    label: 'Dr.'
  },
  {
    value: 'Mr.',
    label: 'Mr.'
  },
  {
    value: 'Mrs.',
    label: 'Mrs.'
  },
  {
    value: 'Ms.',
    label: 'Ms.'
  },
  {
    value: 'Prof.',
    label: 'Prof.'
  }
]
